// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
export type ExemptionTrackingTable_SummaryBeneficiaryFragment = { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string };

export type ExemptionTrackingTable_RecipientBeneficiaryFragment = { __typename?: 'Beneficiary', id: string, summary: (
    { __typename?: 'SummaryBeneficiaryv2' }
    & ExemptionTrackingTable_SummaryBeneficiaryFragment
  ), entity?: { __typename?: 'Entity', id: string, kind: Types.EntityKind } | null };

export type ExemptionTrackingTable_GrantorClientProfileFragment = { __typename?: 'ClientProfile', id: string, displayName: string };

export type ExemptionTrackingTable_LifetimeExclusionEventFragment = { __typename?: 'LifetimeExclusionEvent', id: string, eventDate: Time, giftAmount?: CurrencyUSD | null, giftCategory?: Types.LifetimeExclusionEventGiftCategory | null, kind: Types.LifetimeExclusionEventKind, lifetimeExclusionAmount: CurrencyUSD, gstExclusionAmount: CurrencyUSD, annualExclusionAmount?: CurrencyUSD | null, grantor: (
    { __typename?: 'ClientProfile' }
    & ExemptionTrackingTable_GrantorClientProfileFragment
  ), recipient?: (
    { __typename?: 'Beneficiary' }
    & ExemptionTrackingTable_RecipientBeneficiaryFragment
  ) | null, loggedTransfer?: { __typename?: 'LoggedTransfer', id: string } | null };

export const Operations = {
  Fragment: {
    ExemptionTrackingTable_SummaryBeneficiary: 'ExemptionTrackingTable_SummaryBeneficiary' as const,
    ExemptionTrackingTable_RecipientBeneficiary: 'ExemptionTrackingTable_RecipientBeneficiary' as const,
    ExemptionTrackingTable_GrantorClientProfile: 'ExemptionTrackingTable_GrantorClientProfile' as const,
    ExemptionTrackingTable_LifetimeExclusionEvent: 'ExemptionTrackingTable_LifetimeExclusionEvent' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const ExemptionTrackingTable_GrantorClientProfileFragmentDoc = gql`
    fragment ExemptionTrackingTable_GrantorClientProfile on ClientProfile {
  id
  displayName
}
    `;
export const ExemptionTrackingTable_SummaryBeneficiaryFragmentDoc = gql`
    fragment ExemptionTrackingTable_SummaryBeneficiary on SummaryBeneficiaryv2 {
  id
  displayName
}
    `;
export const ExemptionTrackingTable_RecipientBeneficiaryFragmentDoc = gql`
    fragment ExemptionTrackingTable_RecipientBeneficiary on Beneficiary {
  id
  summary {
    ...ExemptionTrackingTable_SummaryBeneficiary
  }
  entity {
    id
    kind
  }
}
    ${ExemptionTrackingTable_SummaryBeneficiaryFragmentDoc}`;
export const ExemptionTrackingTable_LifetimeExclusionEventFragmentDoc = gql`
    fragment ExemptionTrackingTable_LifetimeExclusionEvent on LifetimeExclusionEvent {
  id
  eventDate
  giftAmount
  giftCategory
  kind
  grantor {
    ...ExemptionTrackingTable_GrantorClientProfile
  }
  lifetimeExclusionAmount
  gstExclusionAmount
  annualExclusionAmount
  recipient {
    ...ExemptionTrackingTable_RecipientBeneficiary
  }
  loggedTransfer {
    id
  }
}
    ${ExemptionTrackingTable_GrantorClientProfileFragmentDoc}
${ExemptionTrackingTable_RecipientBeneficiaryFragmentDoc}`;